import {
    OrganizationAccess,
    OrganizationPermission,
    OrganizationScope,
    OrganizationRestrictionScope,
} from '@/entities'
import { ObjectId, isNullObjectId } from '@/utils/objectid'

export type OrganizationPermissionsErrors =
    `${OrganizationScope}.${keyof OrganizationPermission | 'restricted'}`

export const hasOrganizationPermissions = (
    organizationAccess: Pick<OrganizationAccess, 'owner' | 'permissions' | 'restrictions'> | null | undefined,
    permissions: Partial<Record<OrganizationScope, Partial<OrganizationPermission>>>,
    object: ObjectId | undefined | false | ((scope: OrganizationRestrictionScope) => ObjectId | undefined) = undefined,
    errors: OrganizationPermissionsErrors[] | undefined = []
): boolean => {
    if (!organizationAccess) {
        return false
    }

    if (organizationAccess.owner) {
        return true
    }

    let scope: OrganizationScope
    for (scope in permissions) {
        const requiredPermissions = permissions[scope]
        const availablePermissions = organizationAccess.permissions[scope]

        if (requiredPermissions?.read && !availablePermissions?.read) {
            errors.push(`${scope}.read`)
        }

        if (requiredPermissions?.insert && !availablePermissions?.insert) {
            errors.push(`${scope}.insert`)
        }

        if (requiredPermissions?.edit && !availablePermissions?.edit) {
            errors.push(`${scope}.edit`)
        }

        if (requiredPermissions?.remove && !availablePermissions?.remove) {
            errors.push(`${scope}.remove`)
        }

        if (object !== false) {
            // @ts-expect-error not sure how to fix this
            if (organizationAccess.restrictions?.[scope]?.length) {
                if (object === undefined) {
                    errors.push(`${scope}.restricted`)
                } else {
                    const restrictionScope = scope as OrganizationRestrictionScope
                    let theObject: ObjectId | undefined = undefined

                    if (typeof object === 'function') {
                        theObject = object(restrictionScope)
                    } else {
                        theObject = object
                    }

                    // Let the "null" object go through
                    if (theObject && !isNullObjectId(theObject)) {
                        const idToSearch = theObject.toString()
                        const objects = organizationAccess.restrictions[restrictionScope]!
                        if (!objects.find((id: ObjectId) => id.toString() === idToSearch)) {
                            errors.push(`${scope}.restricted`)
                        }
                    }
                }
            }
        }
    }

    return errors.length === 0
}
